/**
 * Created by mukund on 7/28/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsEmbed', {
                parent: 'site',
                url: '/lms/embed/:windowType/:fileSelectType/:collectionId/:authToken/:enableUpload?',
                data: {
                    roles: [],
                    pageTitle: 'lms-embed.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/lms/embed/templates/lms-embed.html',
                        controller: 'LMSEmbedController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('lms-embed');
                        return $translate.refresh();
                    }]
                }
            });
    });
